import { Component, Injector } from '@angular/core';
import { AppFormComponent } from 'src/app/components/tuain/forms/app-form.component';

const checkFrequency = 60000;
const defaultValidPosition = false;
const SESSION_ESTABLISHED = 'sessionEstablished';
const SESSION_ENDED = 'sessionEnded';
const INVASIVE_NOTIFICATION = 'invasiveNotification';

const frm = {
  name: 'activityCheck',
  states: { default: 'default' },
  sections: { default: 'default' },
  subsections: { default: 'default' },
  fields: {
    lastCheckDate: 'lastCheckDate',
    geolocation: 'geolocation',
    validTime: 'validTime',
    agentPendingTickets: 'agentPendingTickets',
    agentPendingNotifications: 'agentPendingNotifications',
    nextInvasiveNotifications: 'nextInvasiveNotifications',
    agentAccountBalance: 'agentAccountBalance',
    agentAccountBalanceDate: 'agentAccountBalanceDate',
    agentAccountActive: 'agentAccountActive',
    agentValidDistance: 'agentValidDistance',
    notificationToClose: 'notificationToClose',
    notificationCloseType: 'notificationCloseType',
  },
  actions: {
    checkActivity: 'checkActivity',
    closeNotification: 'closeNotification',
  },
  tables: {},
};

@Component({
  selector: 'app-activity-check',
  template: `<div></div>`,
})
export class ActivityCheckComponent extends AppFormComponent {
  checkTimer: any = null;
  activatedCheck = false;
  pendingTickets = 0;
  pendingNotifications = 0;
  validPosition = false;
  lastAgentStatus: any = {};
  activityCheckStart: Date;

  override customPreProcessing() { this.name = frm.name; }

  override customFormStart() {
    this.activityCheckStart = new Date();
    this.disableActivityNotification();
    this.disableServerErrorPopup();
    this.subscribeAppEvents(SESSION_ESTABLISHED, (data) => { this.activateChecking(data); });
    this.subscribeAppEvents(SESSION_ENDED, event => this.deactivateChecking(event));
    // this.subscribeAppEvents('closeInvasiveNotification', (data) => { data && this.closeInvasiveNotification(data); });
    this.onActionStart(frm.actions.checkActivity, async () => {
      const geolocation = await this.getCurrentPosition();
      this.setFieldValue('geolocation', geolocation);
      this._userSession.addCustomSessionData('geolocation', geolocation);
    });
    this.onActionFinish(frm.actions.checkActivity, this.updateObtaindedActivity.bind(this));
  }

  deactivateChecking(event) {
    const { endDate } = event ?? {};
    if (endDate && endDate > this.activityCheckStart) {
      this.activatedCheck = false;
      clearTimeout(this.checkTimer);
    }
  }

  activateChecking(sessionInfo) {
    if (sessionInfo?.sessionData?.sessionId && !this.activatedCheck) {
      this.activatedCheck = true;
      this.startAction(frm.actions.checkActivity);
    }
  }

  restartTimer() {
    if (this.activatedCheck) {
      clearTimeout(this.checkTimer);
      this.checkTimer = setTimeout(() => this.startAction(frm.actions.checkActivity), checkFrequency);
    }
  }

  updateObtaindedActivity() {
    if (this.activatedCheck && !this.errorOccured()) {
      this.refreshAgentInfo();
    }
  }

  refreshAgentInfo() {
    const sessionLost = this.getExtraInfo('sessionLost');
    if (sessionLost === true) {
      this.emitAppEvents(SESSION_ENDED, { endDate: new Date() });
      return;
    } else {
      this.restartTimer();
    }
    const validTime = this.getFieldValue(frm.fields.validTime) || null;
    const pendingNotifications = this.getFieldValue(frm.fields.agentPendingNotifications) || null;

    if (pendingNotifications && !Number.isNaN(pendingNotifications) && pendingNotifications !== this.pendingNotifications) {
      this.emitAppEvents('pendingNotifications', pendingNotifications);
    }
    const currentStatus = {
      validTime,
    };
    const changedStatus = {};
    const agentStatusFields = Object.keys(currentStatus);
    let agentStatusChanged = false;
    for (let index = 0; index < agentStatusFields.length; index++) {
      const fieldName = agentStatusFields[index];
      if (currentStatus[fieldName] !== null && currentStatus[fieldName] !== this.lastAgentStatus[fieldName]) {
        agentStatusChanged = true;
        changedStatus[fieldName] = currentStatus[fieldName];
      }
    }
    if (agentStatusChanged) {
      Object.assign(this.lastAgentStatus, currentStatus);
      this.emitAppEvents('agentStatus', changedStatus);
    }
  }

  closeInvasiveNotification(notificationData) {
    const { id, permanent, nextForm } = notificationData ?? {};
    this.setFieldValue(frm.fields.notificationToClose, id);
    this.setFieldValue(frm.fields.notificationCloseType, permanent);
    this.startAction(frm.actions.closeNotification);
    if (nextForm) {
      this.openForm(nextForm);
    }
  }
}
